import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { TypewriterIllustration } from './Typewriter';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const Typewriter = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <TypewriterIllustration title={title} />
  </IllustrationWrapper>
);
